/* Carrello: tasti + e - piu' visibili (4 ott 2026, Martin: "sbiaditi, non si leggono") */
(function () {
  if (document.getElementById("gf-qty-fix")) return;
  const st = document.createElement("style");
  st.id = "gf-qty-fix";
  st.textContent =
    ".f-cart-drawer .f-quantity,.f-cart .f-quantity{border:1px solid rgba(255,255,255,.6)!important;background:rgba(255,255,255,.08)!important}" +
    ".f-cart-drawer .f-quantity__button,.f-cart .f-quantity__button{color:#fff!important;opacity:1!important;min-width:38px}" +
    ".f-cart-drawer .f-quantity__button svg,.f-cart .f-quantity__button svg{width:20px!important;height:20px!important}" +
    ".f-cart-drawer .f-quantity__button svg path,.f-cart .f-quantity__button svg path{stroke-width:2.6!important}" +
    ".f-cart-drawer .f-quantity__input,.f-cart .f-quantity__input{color:#fff!important;font-weight:700;font-size:16px}" +
    "[dir=rtl] .titan-up__list li{padding-left:0!important;padding-right:26px!important}[dir=rtl] .titan-up__list li:before{left:auto!important;right:0!important}";
  document.head.appendChild(st);
})();
/* Upgrade a Forza Titan nel carrello (4 ott 2026). Cambia il carrello SOLO al clic del cliente. */
if (!customElements.get("titan-upgrade")) {
  class TitanUpgrade extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.btn = this.querySelector("[data-titan-btn]");
      this.sel = this.querySelector("[data-titan-select]");
      if (this.sel) {
        this.sel.addEventListener("change", () => this.sync());
        this.sync();
      }
      if (this.btn) this.btn.addEventListener("click", (e) => { e.preventDefault(); this.go(); });
    }
    sync() {
      const o = this.sel.selectedOptions[0];
      if (!o) return;
      const set = (sel, val) => { const el = this.querySelector(sel); if (el && val) el.innerHTML = val; };
      set("[data-titan-save]", o.dataset.save);
      set("[data-titan-extra]", o.dataset.extra);
      set("[data-titan-base]", o.dataset.base);
      set("[data-titan-total]", o.dataset.total);
    }
    async go() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const vid = Number(this.sel ? this.sel.value : this.dataset.variant);
      let updates = {};
      try { updates = JSON.parse(this.dataset.updates || "{}"); } catch (e) {}
      const opts = (body) => ({ method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
      this.btn.disabled = true;
      this.btn.classList.add("btn--loading");
      try {
        // le chiavi delle righe cambiano dopo ogni modifica: si usa l'id variante (la parte prima dei due punti)
        const byVariant = {};
        Object.keys(updates).forEach((k) => { byVariant[k.split(":")[0]] = updates[k]; });
        // una sola richiesta: aggiunge il Titan e toglie il singolo insieme (se fallisce, il carrello resta com'era)
        const want = Object.assign({}, byVariant);
        want[vid] = 1;
        const res = await fetch(root + "cart/update.js", opts({ updates: want }));
        if (!res.ok) throw new Error("update");
        // controllo: se un altro script ha riscritto il carrello nello stesso momento, si ripete
        for (let i = 0; i < 3; i++) {
          await new Promise((r) => setTimeout(r, 700));
          const cart = await fetch(root + "cart.js").then((r) => r.json());
          const wrong = Object.keys(byVariant).some((v) => {
            const q = cart.items.filter((it) => String(it.variant_id) === String(v)).reduce((a, it) => a + it.quantity, 0);
            return q > byVariant[v];
          });
          const hasTitan = cart.items.some((it) => String(it.variant_id) === String(vid));
          if (!wrong && hasTitan) break;
          const fix = Object.assign({}, byVariant);
          if (!hasTitan) fix[vid] = 1;
          await fetch(root + "cart/update.js", opts({ updates: fix }));
        }
        if (window.FoxThemeSettings && window.FoxThemeSettings.template === "cart") {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
        }
      } catch (e) {
        this.btn.disabled = false;
        this.btn.classList.remove("btn--loading");
        const err = this.querySelector("[data-titan-err]");
        if (err) { err.textContent = (window.FoxThemeStrings && window.FoxThemeStrings.cartError) || "Error, please try again."; err.style.display = "block"; }
      }
    }
  }
  customElements.define("titan-upgrade", TitanUpgrade);
}
